import React from "react";
import { useTranslation } from "react-i18next";
import { EditIcon, Header2, IconButton, SkeletonLoader, NoteIcon, PinIcon, Tooltip } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import HiddenFromClients from "~/components/tasks/Signifiers/HiddenFromClients";
import { Navigation } from "./Navigation";
import { NoteOptions } from "./NoteOptions";

export const Header = ({
  id,
  name,
  hiddenFromClients,
  pinned,
  createdById,
  projectId,
  className,
  onEdit,
  showNavigation,
  children,
  loading,
}) => {
  const { t } = useTranslation();
  if (loading)
    return (
      <div className="tw-mb-4">
        <SkeletonLoader
          as="div"
          data-testid="loader"
          className={classNames("tw-h-[28px] tw-mb-2", className)}
        />
        {children}
      </div>
    );

  return (
    <div className={className}>
      <div className="tw-flex tw-justify-between tw-mb-2">
        <div>
          <NoteIcon
            className="tw-mr-3 tw-align-middle"
            fill="var(--color-theme-800)"
          />

          <Header2
            weight="bold"
            wordBreak="all"
            className="tw-mt-1 tw-align-middle"
            as="span"
          >
            {name}
          </Header2>

          {pinned ? (
            <div className="modal-header-icon tw-inline-flex tw-items-center model-header-icon tw-align-middle">
              <PinIcon />
            </div>
          ) : null}

          <HiddenFromClients
            hiddenFromClients={hiddenFromClients}
            className="modal-header-icon tw-inline-flex tw-align-middle"
          />
        </div>

        <div className="tw-flex tw-h-fit tw-ml-2 tw--mt-1">
          {showNavigation ? (
            <Navigation
              noteId={id}
              projectId={projectId}
            />
          ) : null}
          {onEdit ? (
            <Tooltip title={t("Edit")}>
              <IconButton
                aria-label="Edit"
                className="tw-mr-1"
                variant="text gray"
                onClick={onEdit}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          ) : null}
          <NoteOptions
            id={id}
            projectId={projectId}
            createdById={createdById}
          />
        </div>
      </div>
      {children}
    </div>
  );
};

Header.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string,
  hiddenFromClients: PropTypes.bool,
  pinned: PropTypes.bool,
  createdById: PropTypes.number,
  projectId: PropTypes.number,
  className: PropTypes.string,
  onEdit: PropTypes.func,
  showNavigation: PropTypes.bool,
  loading: PropTypes.bool,
  children: PropTypes.node,
};

Header.defaultProps = {
  hiddenFromClients: false,
  pinned: false,
  showNavigation: false,
  createdById: 0,
  projectId: 0,
};
